import { Component,  Input } from '@angular/core';
import { JoiFile } from 'globals/store/files.model';
import publicHelpers from '../../helpers/public-helpers';
import { CommonModule } from '@angular/common';
import { MatAnchor, MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'calls-to-action',
    template: `
<button mat-button *ngFor="let link of ctas" mat-button color="primary" class="cta" (click)="helpers.goToUrl($event, link.linkUrl)">{{ link.filename }}</button>
`,
    styles: [`
  :host { display: flex; flex-wrap: wrap; }
  button { margin: 0 3px 5px; }
  .cta { border-radius: 34px !important; }
`],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatAnchor],
})
export class CallsToActionComponent {
  @Input() ctas: JoiFile[] = []
  helpers = publicHelpers
}
      